import { FilterBase } from "./filter-base";

export class UserFilter extends FilterBase {
  CompanyId?: number;

  constructor(name?: string, companyId?: number) {
    super(name);
    this.CompanyId = null;

    if (companyId) {
      this.CompanyId = companyId;
    }

    if (name) {
      this.Name = name;
    }
  }
}
